<template lang="pug">
.content-wrap
  .content-top
    .con
      .gbox-wrap.overflow-hidden
        .news-list-wrap.text-white
          .news-listbox
            template(v-if="startRender")
              #preloader
                #loader
            template(v-else)
              template(v-if="newsDetails.length> 0")
                template(v-if="getLanguage==='en'")
                  .iimg
                    img(:src="imgUrl+newsDetails[0].en_image_url")
                    router-link.btn-submit.btn-custom.text-white.w-100(v-if="!isLoggedIn" to="/register") {{ $t('ui.signupNow') }}
                  .ccon(v-html="newsDetails[0].en_full_body")
                template(v-if="getLanguage==='my'")
                  .iimg
                    img(:src="newsDetails[0].mys_image_url == null ? imgUrl+newsDetails[0].en_image_url : imgUrl+newsDetails[0].mys_image_url")
                    router-link.btn-submit.btn-custom.text-white.w-100(v-if="!isLoggedIn" to="/register") {{ $t('ui.signupNow') }}
                  .ccon(v-html="newsDetails[0].mys_full_body == null ? newsDetails[0].en_full_body : newsDetails[0].mys_full_body")
                template(v-if="getLanguage==='zh'")
                  .iimg
                    img(:src="newsDetails[0].cn_image_url == null ? imgUrl+newsDetails[0].en_image_url : imgUrl+newsDetails[0].cn_image_url")
                    router-link.btn-submit.btn-custom.text-white.w-100(v-if="!isLoggedIn" to="/register") {{ $t('ui.signupNow') }}
                  .ccon(v-html="newsDetails[0].cn_full_body == null ? newsDetails[0].en_full_body : newsDetails[0].cn_full_body")
              //- errorPage(v-if="newsDetails.length === 0")
      footerInfo(:target="'/newsdetails'")
</template>
<script>
import config from "@/config";
// import errorPage from '@/views/default/_errorPage.vue'
import footerInfo from '@/views/default/_footerArticle.vue'
export default{
  components:{
    // errorPage
    footerInfo
  },
  data(){
    return{
      feedback:{
        success: true,
        status:""
      },
      loading: false,
      imgUrl: config.imageUrl,
      newsDetails:[],
      metaData: [],
      startRender: true
    }
  },
  // metaInfo(){
  //   if(this.metaData.length> 0){
  //     return{
  //       title: this.metaData[0].meta_title || 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: this.metaData[0].meta_desc },
  //         { name: "keywords", content: this.metaData[0].meta_keywords },
  //         { name: "author", content: this.metaData[0].meta_author },
  //         { name: "publisher", content: this.metaData[0].meta_publisher },

  //         { property: 'og:title', content: this.metaData[0].meta_title },
  //         { property: 'og:description', content: this.metaData[0].meta_desc },
          
  //       ],
  //       link: [
  //         { rel: 'canonical', href: this.metaData[0].meta_canonical }, // Sets the canonical URL
  //       ],
  //     }
  //   }else{
  //     return{
  //       title: 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: 'EpicWin Malaysia' },
  //       ],
  //     }
  //   }
  // },
  computed:{
		isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
	},
  created(){
    var temp = window.location.pathname.split("/")
    var target = temp[temp.length-1]
    this.getNewsDetails(target)
  },
  mounted(){
    // this.getSeo()
    window.scroll(0,0)
  },
  methods:{
    getSeo(){			
      var temp = window.location.pathname.split("/")
      let page_name = temp[temp.length-1]
      let domain_name = window.location.hostname
			this.$store
				.dispatch("user/getSeo", {page_name, domain_name})
				.then(response => {
					this.loading = false;
					this.feedback.success = response.success
					if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
              this.metaData = response.data
						}
					} else {
						if((typeof response.status) != 'object'){
							this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
						}       
					}
				})
				.catch(response => {
					this.loading = false;
					var vm = this;
					if((typeof response.status) != 'object'){
						this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
					}
				});
		},
    getNewsDetails(target){
      var slug = target
      this.$store
        .dispatch("user/getNewsDetails",{slug})
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success
          if (this.feedback.success == true) {
            if(response.data.length > 0){
              this.newsDetails = response.data
            }else{
              this.$router.push("/error").catch(err => {});
            }
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
            }       
          }
          this.startRender = false
        })
        .catch(response => {
          this.loading = false;
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
          }
          this.loading = true
          this.startRender = false
        });
    }
  }
}
</script>